import { setUserId } from '@amplitude/analytics-browser';
import {
  hasUnifiedLoginSession,
  markInboundExchangeFailed,
  unifiedLoginLogout,
} from '../utils/UnifiedLogin';
import { invalidateAuthSessionAttempts } from './authSessionGeneration';

import { hideDecagonForLogout } from '../components/Reports/CandidateLandingPage/decagonLogoutVisibility';

export const LOGOUT_CANDIDATE = 'LOGOUT_CANDIDATE';

export const logoutCandidateComplete = () => ({
  type: LOGOUT_CANDIDATE,
});

const clearAnalyticsUser = () => {
  try {
    setUserId(undefined);
  } catch {
    // Analytics must never break the logout flow
  }
};

const hideChatForLogout = () => {
  try {
    // The embed is mounted on document.body, so it stays on the sign-in
    // screen after the reports page unmounts unless logout dismisses it.
    hideDecagonForLogout();
  } catch {
    // Chat teardown must never break the logout flow
  }
};

/**
 * Best-effort broker teardown for forced logouts. Deliberately not awaited:
 * on a rejected credential the local session must be cleared immediately, so
 * the broker relay round trip cannot keep it alive in the meantime.
 */
export const teardownUnifiedLoginSession = () => {
  // A restore still in flight must not be able to log the candidate back in
  // after this.
  invalidateAuthSessionAttempts();
  clearAnalyticsUser();
  hideChatForLogout();
  if (hasUnifiedLoginSession()) {
    // A forced logout while holding a broker session means the app could not
    // use that session. Latch it: tearing down clears the marker, and without
    // this kickoff would see a clean slate, bounce off a broker that still has
    // a session, mint another unusable token and loop.
    markInboundExchangeFailed();
    unifiedLoginLogout().catch(() => {});
  }
};

export const logoutCandidate = () => async dispatch => {
  // Same reason as teardownUnifiedLoginSession: supersede any in-flight
  // auth-session attempt before the broker round trip starts.
  invalidateAuthSessionAttempts();
  clearAnalyticsUser();
  hideChatForLogout();
  // Belt and braces: unifiedLoginLogout already reports and resolves false
  // rather than rejecting, but local logout must never be blocked by a broker
  // problem, so a rejection here cannot become an unhandled rejection either.
  if (hasUnifiedLoginSession()) {
    await unifiedLoginLogout().catch(() => {});
  }
  return dispatch(logoutCandidateComplete());
};
